import { Injectable } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AllocationViewActionsFacade } from '../allocation-view-actions.facade';
import { AllocationViewSelectedEntityModel } from '../../models';
import { AllocationViewActionInterface } from '../models';
import { AllocationViewCoupleActionState } from './allocation-view-couple-action.state';
import {
  AllocationViewCoupleAction,
  AllocationViewCoupleSetInitialState,
} from './allocation-view-couple-action.actions';

@Injectable({ providedIn: 'root' })
export class AllocationViewCoupleActionFacade implements AllocationViewActionInterface {
  loaded$: Observable<boolean> = this.store.select(AllocationViewCoupleActionState.getLoaded);

  constructor(private allocationViewActionsFacade: AllocationViewActionsFacade, private store: Store) {}

  execute(): void {
    this.allocationViewActionsFacade.actionIdentifier$
      .pipe(filter(Boolean), take(1))
      .subscribe(({ identifier }: AllocationViewSelectedEntityModel) => {
        this.store.dispatch(
          new AllocationViewCoupleAction({
            identifier,
          }),
        );
      });
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewCoupleSetInitialState());
  }
}
